import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import '../../static/less/new_shopping_cart/RegisterReminderBlock.css';
import formatCurrency from 'format-currency';
import {
  setShowLastChanceToRegister, setLastChanceRegisterConfirmed, setShowLogin, setShowRegistration,
  checkOutCoinsInCaseUserDecidesToRegister, setCheckoutCoins,
} from '../../actions/Loyalty';
import { getPhotoThumb } from '../../utils/Generic';

const RegisterReminderBlock = (props, context) => {
  // Cargar los coins cuando el componente se monte
  useEffect(() => {
    props.checkOutCoinsInCaseUserDecidesToRegister();
    // Limpiar los coins cuando el componente se desmonte
    return () => {
      props.setCheckoutCoins(0);
    };
  }, []);

  const handleLoginClick = () => {
    props.setShowLastChanceToRegister(false);
    props.setShowLogin(true);
    props.setShowRegistration(false);
    props.setLastChanceRegisterConfirmed(false);
  };

  const handleRegisterClick = () => {
    props.setShowLastChanceToRegister(false);
    props.setShowLogin(false);
    props.setShowRegistration(true);
    props.setLastChanceRegisterConfirmed(false);
  };

  /*const handleContinueWithoutLoyaltyClick = () => {
    props.setShowLastChanceToRegister(false);
    props.setShowLogin(false);
    props.setShowRegistration(false);
    props.setLastChanceRegisterConfirmed(true);
  };*/
  // No usamos esto, antes se usaba porque había un botón de continue without account pero decidieron quitarlo
  // así que ahora con cerrar el pop up se lanza esa acción

  const discount = formatCurrency(props.cart.amount[props.currency.code]
    * (props.new_member_discount_percentage_chain / 100), props.currency);

  const currency_to_use_coins = props.hotel.city.zone.country.iso_code === 'MX' ? 'USD' : 'EUR';
  const width = 422;
  const height = 282;
  return (
    <div className="register-reminder-discount-container">
      <div className="register-remindercontent-row">
        {/* Columna izquierda - Imagen (deberás reemplazar con tu imagen real) */}
        <div className="register-reminder-image-column">
          {props.cart.cartHotel.rooms[0].room.photos.length > 0 && getPhotoThumb({
            url: props.cart.cartHotel.rooms[0].room.photos[0].url,
            width,
            height,
            extraClass: 'register-reminder-promo-image',
          })}
          {/*<img
            src={LastChanceToRegisterImage}
            alt="Oferta especial S4U"
            className="register-reminder-promo-image"
          />*/}
        </div>

        {/* Columna derecha - Textos */}
        <div className="register-reminder-text-column">
          {props.lang === 'en'
            && <div className="register-reminder-main-title">
              <span className='whiteColor'>{'YOUR LAST CHANCE TO BECOME A'}</span>&nbsp;
              <span className='goldColor'>{'Sandos4u'}</span>&nbsp;
              <span className='whiteColor'>{'MEMBER TO'}</span>&nbsp;
              <span className='goldColor'>{'SAVE NOW!'}</span>&nbsp;
              <span className='whiteColor'>{'AND'}</span>&nbsp;
              <span className='goldColor'>{'GET:'}</span>
              </div>
          }
          {props.lang === 'es'
            && <div className="register-reminder-main-title">
              <span className='whiteColor'>{'¡TU ÚLTIMA OPORTUNIDAD PARA SER MIEMBRO DE'}</span>&nbsp;
              <span className='goldColor'>{'Sandos4u'}</span> <span className='whiteColor'>{'Y'}</span>&nbsp;
              <span className='goldColor'>{context.t('AHORRAR AHORA!')}</span> <span className='whiteColor'>{'Y'}</span>&nbsp;
              <span className='goldColor'>{context.t('OBTENER:')}</span>
              </div>
          }
          {props.lang === 'de'
            && <div className="register-reminder-main-title">
              <span className='whiteColor'>{'IHRE LETZTE CHANCE, MITGLIED ZU WERDEN'}</span>&nbsp;
              <span className='goldColor'>{'Sandos4u'}</span> <span className='whiteColor'>{'UM'}</span>&nbsp;
              <span className='goldColor'>{'JETZT ZU SPAREN!'}</span> <span className='whiteColor'>{'UND'}</span>&nbsp;
              <span className='goldColor'>{'ZU ERHALTEN:'}</span>
              </div>
          }
          {props.lang === 'fr'
            && <div className="register-reminder-main-title">
              <span className='whiteColor'>{'VOTRE DERNIÈRE CHANCE DE DEVENIR MEMBRE DE'}</span>
              <span className='goldColor'>{'Sandos4u'}</span>
              <span className='whiteColor'>{'POUR'}</span>
              <span className='goldColor'>{'ÉCONOMISER MAINTENANT!'}</span>
              <span className='whiteColor'>{'ET'}</span> <span className='goldColor'>{'OBTENIR:'}</span>
              </div>
          }
          <div className="register-reminder-offer-section">
            <div className="register-reminder-offer-label">{context.t('{loyaltyName} Discount', { loyaltyName: 'S4U' })}</div>
            <div className="register-reminder-offer-amount">{discount}</div>
          </div>

          {props.checkoutCoins !== 0
          && <Fragment>
            <div className="register-reminder-offer-section">
              <div className="register-reminder-offer-label">{context.t('Plus')}</div>
              <div className="register-reminder-offer-amount">
                {props.checkoutCoins} {context.t('COINS*')}
                <div className="register-reminder-checkout-moment">
                  {context.t('At the moment of Check-Out')}
                </div>
              </div>
            </div>

            <div className="register-reminder-disclaimer">
              {context.t('*Approximate amount of Coins')}
              <br/>
              {context.t('**1 S4U Coin = $1 {currency_to_use_coins}', { currency_to_use_coins })}
            </div>
          </Fragment>
          }
        </div>
      </div>

      {/* Sección CTA abajo */}
      <div className="register-reminder-cta-section">
        <div className="register-reminder-cta-text">{context.t('Register or log-in Now at {loyalty_name}', { loyalty_name: 'Sandos4u' })}</div>
        <div className="register-reminder-buttons-container">
          <button className="register-reminder-cta-button" onClick={handleLoginClick}>{context.t('Log-In')}</button>
          <button className="register-reminder-cta-button continue-without-account"
            onClick={handleRegisterClick}>
            {context.t('Create Account')}
          </button>
        </div>
      </div>
    </div>
  );
};

// Definimos las propTypes para asegurarnos de que las propiedades tengan los tipos correctos
RegisterReminderBlock.propTypes = {
  setShowLastChanceToRegister: PropTypes.func.isRequired,
  setShowLogin: PropTypes.func.isRequired,
  setShowRegistration: PropTypes.func.isRequired,
  setLastChanceRegisterConfirmed: PropTypes.func.isRequired,
  loyaltyName: PropTypes.string.isRequired,
  cart: PropTypes.object.isRequired,
  currency: PropTypes.object.isRequired,
  new_member_discount_percentage_chain: PropTypes.number.isRequired,
  checkoutCoins: PropTypes.number,
  checkOutCoinsInCaseUserDecidesToRegister: PropTypes.func.isRequired,
  clearCheckoutCoins: PropTypes.func.isRequired,
};

RegisterReminderBlock.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
  loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
  currencies: state.booking.currencies,
  cart: state.cart,
  currency: state.booking.filterCurrency,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
  hotel: state.booking.hotel,
  checkoutCoins: state.loyalty.checkoutCoins,
});

const mapDispatchToProps = (dispatch) => ({
  setShowLastChanceToRegister: (show) => dispatch(setShowLastChanceToRegister(show)),
  setShowLogin: (show) => dispatch(setShowLogin(show)),
  setShowRegistration: (show) => dispatch(setShowRegistration(show)),
  setLastChanceRegisterConfirmed: (show) => dispatch(setLastChanceRegisterConfirmed(show)),
  checkOutCoinsInCaseUserDecidesToRegister: () => dispatch(checkOutCoinsInCaseUserDecidesToRegister()),
  setCheckoutCoins: (checkoutCoins) => dispatch(setCheckoutCoins(checkoutCoins)),

});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterReminderBlock);
